module.exports = __webpack_public_path__ + "img/logo_hua.8b284e5b.png";